import type { Translations } from "../types";

const es: Translations = {
  "meta.title": "Mapa de clics por país",
  "meta.description":
    "Mapa mundial interactivo: clics gratuitos por país además de apoyo de pago mediante Stripe, PayPal y Buy Me a Coffee.",

  "app.title": "Mapa de clics por país",

  "map.intro":
    "Haz clic en un país del mapa para darle un voto gratuito, o envíale apoyo económico - ambos cuentan para la clasificación combinada de abajo. El mapa refleja solo el apoyo dentro de esta app, no la riqueza nacional real ni el PIB.",
  "map.verifying": "Verificando …",
  "map.confirmNotRobot": "Antes de poder añadir clics gratuitos, confirma rápidamente que no eres un robot:",
  "map.tryAgain": "Inténtalo de nuevo",
  "map.registeringClick": "Registrando clic …",
  "map.selectedCountry": "País seleccionado: {name}.",
  "map.selectFirstFeedback": "País seleccionado. Para añadir un clic gratuito, primero confirma abajo que no eres un robot.",
  "map.verificationExpired": "La verificación ha caducado - confirma de nuevo que no eres un robot.",
  "map.slowDown": "Un poco más despacio - espera un momento antes de tu próximo clic.",
  "map.clickFailed": "No se pudo registrar el clic. Inténtalo de nuevo.",
  "map.clickErrorGeneric": "Error al registrar el clic.",
  "map.leaderboardHeading": "Clasificación de países",
  "map.emptySelection": "Selecciona un país en el mapa para votarlo o apoyarlo.",
  "map.loadingData": "Cargando datos …",

  "worldmap.loadError": "No se pudo cargar el mapa.",
  "worldmap.resetZoom": "Restablecer zoom",
  "worldmap.resetButton": "⤾ Restablecer",
  "worldmap.loadingMap": "Cargando mapa …",
  "worldmap.unknownCountry": "Desconocido",
  "worldmap.ariaClicks": "{name}: {clicks} clics",
  "worldmap.tooltipClicks": "{clicks} clics",

  "legend.fewer": "Menos clics",
  "legend.more": "Más clics",

  "list.empty": "Aún no hay clics. ¡Sé el primero!",
  "list.ariaLabel": "Clasificación de países por clics",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY no está configurada - consulta el README para la configuración.",
  "human.verificationFailedGeneric": "La verificación falló.",
  "human.networkError":
    "No se pudo contactar con la verificación (error de red) - revisa VITE_SUPABASE_URL, que verify-human esté desplegada, y ALLOWED_ORIGIN; consulta README/NAVODILA.",
  "human.verificationFailedRetry": "La verificación falló, inténtalo de nuevo.",

  "provider.stripe": "💳 Tarjeta (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "País seleccionado",
  "panel.currentlyRanked": "Actualmente en el puesto #{rank}",
  "panel.shareCopied": "Copiado ✓",
  "panel.shareShared": "Compartido ✓",
  "panel.shareButton": "🔗 Compartir",

  "panel.tableClicks": "Clics",
  "panel.tableFree": "Gratis",
  "panel.tablePaid": "De pago",
  "panel.rowAllTime": "Total histórico",
  "panel.rowThisYear": "Este año",
  "panel.rowThisWeek": "Esta semana",
  "panel.rowToday": "Hoy",

  "panel.totalCombined": "Total combinado:",
  "panel.totalSupport": "Apoyo total:",

  "panel.paymentMethod": "Método de pago",
  "panel.noPaymentMethod": "Actualmente no hay ningún método de pago disponible.",
  "panel.supportAmount": "Importe del apoyo (EUR)",
  "panel.amountRange": "El importe debe estar entre {min} y {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Clics de pago estimados:",
  "panel.ratioInfo":
    "Proporción: {a} = {b} clics (p. ej. {c} = {d} clics). Esto es solo una estimación antes del pago - el número final de clics siempre lo calcula y confirma el servidor según el pago realmente confirmado.",
  "panel.preparing": "Preparando …",
  "panel.continueWith": "Continuar con {provider}",
  "panel.choosePaymentMethod": "Elige un método de pago",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME no está configurada - consulta el README para la configuración.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID no está configurada - consulta el README para la configuración.",

  "panel.paypalAmountInfo": "Importe: {amount} (estimado {clicks} clics). Completa el pago con el botón de PayPal de abajo.",
  "panel.back": "← Atrás",

  "panel.bmcWarningTitle": "⚠️ Antes de continuar a BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Pega el código de abajo en el campo de mensaje/nota al pagar — es la única forma de saber a qué país estás apoyando. Sin el código, no podemos atribuir el pago a ningún país.",
  "panel.copy": "Copiar",
  "panel.copied": "Copiado ✓",
  "panel.suggestedAmount": "Importe sugerido:",
  "panel.bmcAmountNote":
    "(estimado {clicks} clics). BuyMeCoffee lamentablemente no permite trasladar el importe mediante enlace — introdúcelo o selecciónalo tú mismo en su sitio. El número real de clics siempre se calcula a partir del importe que realmente envíes en BuyMeCoffee, no de esta estimación.",
  "panel.openBmc": "Abrir BuyMeCoffee y continuar →",
  "panel.waitingProvider": "Esperando confirmación de pago del proveedor de pago …",
  "panel.waitingConfirmation": "Esperando confirmación de pago …",
  "panel.timedOut":
    "Se agotó el tiempo de comprobación. Si completaste el pago, el mapa se actualizará en cuanto el servidor reciba la confirmación - esto a veces puede tardar un poco más.",
  "panel.checkAgain": "Comprobar de nuevo",

  "panel.cancelled": "El pago se canceló o no se completó. El mapa no ha cambiado.",
  "panel.tryAgain": "Inténtalo de nuevo",

  "panel.confirmed": "✅ ¡Apoyo confirmado!",
  "panel.confirmedBody": "{country} recibió {clicks} clics de pago por {amount}.",

  "panel.errorPreparingSupport": "Error al preparar tu apoyo.",
  "panel.errorPreparingPayment": "Error al preparar el pago.",
  "panel.errorConfirmingPayment": "Error al confirmar el pago.",
  "panel.errorPayingPaypal": "Error al pagar con PayPal.",

  "share.unranked": "¡{flag}{country} necesita tu apoyo en el mapa mundial!\nAyúdalo a subir en la clasificación 👇",
  "share.rank1": "¡{flag}{country} está actualmente en el puesto #1!\nAyúdanos a seguir en la cima 👇",
  "share.rankN": "¡{flag}{country} está actualmente en el puesto #{rank}!\nAyúdanos a llegar al #1 👇",

  "language.switcherLabel": "Idioma",
};

export default es;
